import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { FormControl, InputLabel, FormHelperText } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Typography from "@material-ui/core/Typography";
import InformationTooltip from "components/CustomTooltips/InformationTooltip.js";
import styles from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomButton from "components/CustomButtons/CustomButton";
import EmailLogin from "components/CustomIcons/EmailLogin";
import PhoneLogin from "components/CustomIcons/Phone";
import PhoneCall from "components/CustomIcons/PhoneCall";
import Alert from "components/CustomIcons/Alert";
import File from "components/CustomIcons/File";
import Paper from "components/CustomIcons/Paper";
import Collapsible from "components/Collapsible/Collapsible";
import CustomModal from "components/CustomModal/Modal";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import { useTranslation } from "react-i18next";

import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import { getResources } from "views/Services/ClientService";

const useStyles = makeStyles((theme) => ({
  ...styles,
  errorBorder: {
    border: "1px solid red",
    borderRadius: "4px",
    padding: "4px",
  },
}));

const useStylesModal = makeStyles(stylesModal);

export default function CustomResource(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const classesModal = useStylesModal();
  const dispatch = useDispatch();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    rtlActive,
    items,
    defaultValue,
    information,
    inline,
    secondaryText,
  } = props;

  const [valor, setValor] = useState(defaultValue || null);
  const [hasError, setHasError] = useState(false);
  const [resources, setResources] = useState([]);
  const [isOpenSafe, setIsOpenSafe] = useState(false);
  const [isOpenFirst, setIsOpenFirst] = useState(false);
  const [isOpenClaim, setIsOpenClaim] = useState(false);
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (defaultValue) {
      setValor(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    getResourceList();
  }, [dispatch]);
  const getResourceList = async () => {
    const resultSubmit = await dispatch(getResources({}));
    setResources(resultSubmit.payload.files);
  };

  const handleValorChange = (event, newValor) => {
    if (newValor !== null) {
      setValor(newValor);
      event.target.name = inputProps.name;
      inputProps.onChange(event);
    }
  };

  const formControlClasses = classNames(
    formControlProps?.className,
    classes.formControl
  );

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
    [classes.labelRTL]: rtlActive,
  });

  const toggleGroupClasses = classNames({
    [classes.errorBorder]: hasError,
  });

  return (
    <GridItem xs={12}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={7} lg={7}>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <h3
                    className={classes.cardTitle}
                    style={{
                      paddingTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        textAlign: "center",
                        lineHeight: "50px",
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#EFEFEF",
                        marginRight: "20px",
                        borderRadius: "10px",
                        paddingTop: "1%",
                      }}
                    >
                      <Paper />
                    </span>
                    {t("resources.title")}
                  </h3>
                  <p
                    className={classes.cardCategory}
                    style={{
                      paddingTop: "40px",
                      paddingBottom: "35px",
                      color: "#000000",
                      textAlign: "left",
                    }}
                  >
                    <span>{t("resources.getSupport")}</span>
                  </p>
                </CardHeader>
              </Card>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader>
                  <h3
                    className={classes.cardTitle}
                    style={{
                      paddingTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        textAlign: "center",
                        lineHeight: "50px",
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#FFC14B",
                        marginRight: "20px",
                        borderRadius: "10px",
                      }}
                    >
                      <Alert />
                    </span>
                    {t("resources.claims.title")}
                  </h3>
                  <p
                    className={classes.cardCategory}
                    style={{
                      paddingTop: "40px",
                      paddingBottom: "35px",
                      color: "#000000",
                      textAlign: "left",
                    }}
                  >
                    <span>{t("resources.claims.mustReport")}</span>
                    <br className={"brClass"} />
                    <PhoneLogin
                      style={{
                        color: "#008670",
                        width: "20px",
                        marginBottom: "-10px",
                      }}
                    />
                    <strong> 800-284-9783</strong>
                    <br className={"brClass"} />
                    <PhoneLogin
                      style={{
                        color: "#008670",
                        width: "20px",
                        marginBottom: "-10px",
                      }}
                    />
                    <strong> 956-682-1353</strong>
                    <br className={"brClass"} />
                    <EmailLogin width="18" height="18" />
                    <a
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                      href="mailto:jorge@ICclaims.com"
                    >
                      <span> jorge@ICclaims.com</span>
                    </a>
                    <br className={"brClass"} />
                    <File
                      style={{
                        color: "#008670",
                        width: "20px",
                        marginBottom: "-10px",
                      }}
                    />
                    <a
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                      href="../assets/documentation/Documentation/In case of an accident.pdf"
                      target="_blank"
                    >
                      <span> {t("resources.claims.accidentDoc")}</span>
                    </a>
                  </p>
                </CardHeader>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <Card>
                <CardHeader>
                  <h3
                    className={classes.cardTitle}
                    style={{
                      paddingTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        textAlign: "center",
                        lineHeight: "50px",
                        width: "50px",
                        height: "50px",
                        backgroundColor: "#FFC14B",
                        marginRight: "20px",
                        borderRadius: "10px",
                      }}
                    >
                      <PhoneCall />
                    </span>
                    {t("resources.callUs.title")}
                  </h3>
                  <p
                    className={classes.cardCategory}
                    style={{
                      paddingTop: "40px",
                      paddingBottom: "35px",
                      color: "#000000",
                      textAlign: "left",
                    }}
                  >
                    <span>{t("resources.claims.mustReport2")}</span>
                    <br className={"brClass"} />
                    <strong>
                      <PhoneLogin
                        style={{
                          color: "#008670",
                          width: "20px",
                          marginBottom: "-10px",
                        }}
                      />{" "}
                      477-740-2818
                      <br className={"brClass"} />
                      <PhoneLogin
                        style={{
                          color: "#008670",
                          width: "20px",
                          marginBottom: "-10px",
                        }}
                      />
                      011-52-477-740-2818
                      <br className={"brClass"} />
                      <PhoneLogin
                        style={{
                          color: "#008670",
                          width: "20px",
                          marginBottom: "-10px",
                        }}
                      />
                      +52-477-740-2818
                    </strong>
                    <br className={"brClass"} />
                    <p>
                      {t("resources.callUs.press")}{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {t("resources.callUs.spanishOption")}
                      </span>
                    </p>
                    <p>
                      <a
                        href="https://www.inm.gob.mx/fmme/publico/en/solicitud.html"
                        target="_blank"
                      >
                        FMM
                      </a>
                    </p>
                    <p>
                      <span>{t("resources.fmm")}</span>
                    </p>
                    <p>
                      <span>
                        <a
                          href="https://www.sanborns.com/vehicle-permit/"
                          target="_blank"
                        >
                          {t("resources.vehicleImportation")}
                        </a>
                      </span>
                    </p>
                    <p>
                      <span>
                        <a
                          href="https://www.sanborns.com/international-medical-insurance/"
                          target="_blank"
                        >
                          {t("resources.internationalMedical")}
                        </a>
                      </span>
                    </p>
                  </p>
                </CardHeader>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12} md={5} lg={5}>
          <GridContainer>
            {/* Preguntas Frecuentes */}
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <h3
                    className={classes.cardTitle}
                    style={{
                      paddingTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    {t("faq.title")}
                  </h3>
                  <br className={"brClass"} />
                  <Collapsible title={t("faq.q1.title")}>
                    <p>{t("faq.q1.answer")}</p>
                  </Collapsible>
                  <Collapsible title={t("faq.q2.title")}>
                    <p>{t("faq.q2.answer")}</p>
                  </Collapsible>
                  <Collapsible title={t("faq.q3.title")}>
                    <p>{t("faq.q3.answer")}</p>
                  </Collapsible>
                  <Collapsible title={t("faq.q4.title")}>
                    <p>{t("faq.q4.answer")}</p>
                  </Collapsible>
                  <Collapsible title={t("faq.q5.title")}>
                    <p>{t("faq.q5.answer")}</p>
                  </Collapsible>
                </CardHeader>
              </Card>
            </GridItem>

            {/* Documentación */}
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <h3
                    className={classes.cardTitle}
                    style={{
                      paddingTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    {t("documentation.title")}
                  </h3>
                  <br className={"brClass"} />
                  {resources &&
                    resources.map((item) => {
                      if (
                        item.name &&
                        ![
                          "sanborns_insurance_application_2015",
                          "motorcycle_endorsement_2015",
                          "sanborns_mexican_rental_ins_app_2015",
                        ].includes(item.name)
                      ) {
                        return (
                          <GridItem xs={12} key={item.name}>
                            <File
                              style={{
                                color: "#008670",
                                width: "20px",
                                marginBottom: "-10px",
                                marginRight: "100px",
                              }}
                            />
                            <a
                              href={`${item.url}/${item.path}`}
                              target="_blank"
                              style={{ textDecoration: "underline" }}
                            >
                              <strong>{item.name}</strong>
                              <br className={"brClass"} />
                            </a>
                          </GridItem>
                        );
                      }
                    })}
                </CardHeader>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>{" "}
      </GridContainer>
      <CustomModal
        title={t("modal.safe.title")}
        isOpen={isOpenSafe}
        onClose={setIsOpenSafe}
        privacy={false}
      >
        <GridContainer>
          <GridItem xs={1}></GridItem>
          <GridItem xs={5}>
            <CustomButton
              id="reportClaim"
              type="submit"
              variant="green"
              onClick={() => setIsOpenSafe(false)}
              block
            >
              {t("modal.safe.yes")}
            </CustomButton>
          </GridItem>
          <GridItem xs={5}>
            <CustomButton
              id="reportClaim"
              type="submit"
              variant="red"
              onClick={() => {
                setIsOpenFirst(true);
                setIsOpenSafe(false);
              }}
              block
            >
              {t("modal.safe.no")}
            </CustomButton>
          </GridItem>
        </GridContainer>
      </CustomModal>

      {/* Modal: Llamar 911 */}
      <CustomModal
        title={t("modal.first.title")}
        isOpen={isOpenFirst}
        onClose={setIsOpenFirst}
        privacy={false}
      >
        <GridContainer>
          <GridItem xs={12}>{t("modal.first.message")}</GridItem>
          <GridItem xs={12} sm={12} md={5} lg={5}>
            <CustomButton
              id="reportClaim"
              type="submit"
              variant="red"
              onClick={() => {
                setIsOpenFirst(false);
              }}
              block
            >
              {t("modal.first.call")}
            </CustomButton>
          </GridItem>
          <GridItem xs={12} sm={12} md={7} lg={7}>
            <CustomButton
              id="reportClaim"
              type="submit"
              variant="green"
              onClick={() => {
                setIsOpenFirst(false);
                setIsOpenClaim(true);
              }}
              block
            >
              {t("modal.first.continue")}
            </CustomButton>
          </GridItem>
        </GridContainer>
      </CustomModal>

      {/* Modal: Datos de Contacto */}
      <CustomModal
        title=""
        isOpen={isOpenClaim}
        onClose={setIsOpenClaim}
        privacy={false}
      >
        <div style={{ textAlign: "left", margin: "auto", width: "80%" }}>
          <span>{t("modal.claim.message")}</span>
          <br className={"brClass"} />
          <CustomInput
            labelText={t("modal.claim.fullName")}
            error={fullName === ""}
            formControlProps={{
              fullWidth: true,
              className: classesModal.customFormControlClasses,
            }}
            inputProps={{
              name: "fullName",
              id: "fullName",
              value: fullName,
              onChange: (e) => inputHandler(e),
            }}
          />
          <CustomInput
            labelText={t("modal.claim.phone")}
            error={phone === ""}
            formControlProps={{
              fullWidth: true,
              className: classesModal.customFormControlClasses,
            }}
            inputProps={{
              id: "phone",
              name: "phone",
              value: phone,
              onChange: (e) => inputHandler(e),
            }}
          />
          <CustomButton
            id="agreeContinue"
            type="submit"
            variant="green"
            onClick={() => {
              setIsOpenClaim(false);
            }}
            block
          >
            {t("modal.claim.agree")}
          </CustomButton>
        </div>
      </CustomModal>
    </GridItem>
  );
}
